import { useTraduccion } from '@tallerya/i18n';
import { useAuth } from 'react-oidc-context';
import { BrowserRouter, NavLink, Route, Routes } from 'react-router';
import { Inicio } from './paginas/Inicio';
import { Acceso } from './sesion/Acceso';

// El armazón de la consola (M-8): la navegación y dónde se dibuja cada ruta.
//
// Todo va dentro de `Acceso`: la cabecera también. Quien no es del equipo no ve
// ni el menú, que ya dice qué se puede hacer acá.
//
// Las pantallas de verdad llegan con M-9 (alta de un taller) y M-10 (la lista de
// talleres). Cada una suma su ruta y su enlace.
export function App() {
  const { t } = useTraduccion();

  return (
    <BrowserRouter>
      <Acceso>
        <div className="marco">
          <header className="cabecera">
            <span className="marca">{t('plataforma.marca')}</span>
            <nav>
              <NavLink to="/" end>
                {t('plataforma.nav.inicio')}
              </NavLink>
            </nav>
            <Sesion />
          </header>

          <main className="contenido">
            <Routes>
              <Route path="/" element={<Inicio />} />
              <Route path="*" element={<NoEncontrada />} />
            </Routes>
          </main>
        </div>
      </Acceso>
    </BrowserRouter>
  );
}

// Quién está adentro y cómo salir. Acá siempre hay sesión: `Acceso` no deja
// llegar sin ella.
function Sesion() {
  const { t } = useTraduccion();
  const auth = useAuth();

  return (
    <span className="sesion">
      {auth.user?.profile.preferred_username}{' '}
      {/* `signoutRedirect` cierra la sesión en Keycloak, no solo acá. */}
      <button type="button" onClick={() => void auth.signoutRedirect()}>
        {t('plataforma.sesion.salir')}
      </button>
    </span>
  );
}

function NoEncontrada() {
  const { t } = useTraduccion();
  return (
    <>
      <h1>{t('plataforma.noEncontrada.titulo')}</h1>
      <p>{t('plataforma.noEncontrada.texto')}</p>
    </>
  );
}
